/**
 * Whether a link in an answer can be followed as written. Only an absolute address can: a relative
 * one resolves against whatever page the assistant happens to be open on, so the same answer goes
 * somewhere different from Reports than from Leads, and never where it was meant to. The model has
 * written exactly that — `…/extension?profileId=21480`, opened as /reports/…/extension — when it
 * built a link itself instead of copying the one a tool returned.
 *
 * A link that fails this is shown as its words and nothing else, not repaired: there is no way to
 * know from here which page it was meant to be.
 *
 * `msteams:` is the link the server adds under an error the assistant could not explain, opening a
 * Teams chat with the support account and the error's reference already typed.
 */
export const isFollowableLink = (href) =>
    typeof href === "string" && /^(https?:\/\/|mailto:|tel:|msteams:)/i.test(href.trim());

/**
 * DOMPurify's own URI allowlist with `msteams:` added — without it the sanitiser strips the href
 * isFollowableLink just let through, and the Teams link renders as an anchor that goes nowhere.
 */
export const ANSWER_URI_REGEXP = /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp|msteams):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i;
